<template>
  <div>
    <surveys-table
      surveyName="HURLEY"
      surveyCode="HUR"
      :permission="{
        createSurvey: permissions.CREATE_SURVEY_HURLEY,
        viewDetail: permissions.SEE_DETAIL_SURVEY_HURLEY,
      }"
    ></surveys-table>
  </div>
</template>

<script>
import SurveysTable from "../../../components/Forms/SurveysTable.vue";
import { permissions } from "../../../enum/applicationPermissions";

export default {
  components: {
    SurveysTable,
  },
  data() {
    return {
      permissions: permissions,
    };
  },
};
</script>

<style scoped></style>
